export function matchesSearchText(query: string, ...values: unknown[]): boolean {
  const needle = query.trim().toLocaleLowerCase();
  if (!needle) return false;

  return values.some((value) =>
    typeof value === "string" && value.toLocaleLowerCase().includes(needle),
  );
}

export function extractSearchItems<T>(payload: unknown): T[] {
  if (Array.isArray(payload)) return payload as T[];
  if (!payload || typeof payload !== "object") return [];

  const record = payload as Record<string, unknown>;
  if (Array.isArray(record.data)) return record.data as T[];
  if (Array.isArray(record.items)) return record.items as T[];
  if (record.data && typeof record.data === "object") {
    return extractSearchItems<T>(record.data);
  }
  return [];
}
